import { Action } from 'redux';
import { Manifest } from './types';
import { ErrorResponse } from 'core/http/response';

export enum ManifestActions {
    GET_MANIFEST_BY_ID_REQUEST = 'GET_MANIFEST_BY_ID_REQUEST',
    GET_MANIFEST_BY_ID_SUCCESS = 'GET_MANIFEST_BY_ID_SUCCESS',
    GET_MANIFEST_BY_ID_ERROR = 'GET_MANIFEST_BY_ID_ERROR',
    CREATE_MANIFEST_REQUEST = 'CREATE_MANIFEST_REQUEST',
    CREATE_MANIFEST_SUCCESS = 'CREATE_MANIFEST_SUCCESS',
    CREATE_MANIFEST_ERROR = 'CREATE_MANIFEST_ERROR',
    UPDATE_MANIFEST_REQUEST = 'UPDATE_MANIFEST_REQUEST',
    UPDATE_MANIFEST_SUCCESS = 'UPDATE_MANIFEST_SUCCESS',
    UPDATE_MANIFEST_ERROR = 'UPDATE_MANIFEST_ERROR',
    ARCHIVE_MANIFEST_REQUEST = 'ARCHIVE_MANIFEST_REQUEST',
    ARCHIVE_MANIFEST_SUCCESS = 'ARCHIVE_MANIFEST_SUCCESS',
    ARCHIVE_MANIFEST_ERROR = 'ARCHIVE_MANIFEST_ERROR',
    UNARCHIVE_MANIFEST_REQUEST = 'UNARCHIVE_MANIFEST_REQUEST',
    UNARCHIVE_MANIFEST_SUCCESS = 'UNARCHIVE_MANIFEST_SUCCESS',
    UNARCHIVE_MANIFEST_ERROR = 'UNARCHIVE_MANIFEST_ERROR',
    ADD_JOB_TO_MANIFEST_REQUEST = 'ADD_JOB_TO_MANIFEST_REQUEST',
    ADD_JOB_TO_MANIFEST_SUCCESS = 'ADD_JOB_TO_MANIFEST_SUCCESS',
    ADD_JOB_TO_MANIFEST_ERROR = 'ADD_JOB_TO_MANIFEST_ERROR',
    REMOVE_JOB_FROM_MANIFEST_REQUEST = 'REMOVE_JOB_FROM_MANIFEST_REQUEST',
    REMOVE_JOB_FROM_MANIFEST_SUCCESS = 'REMOVE_JOB_FROM_MANIFEST_SUCCESS',
    REMOVE_JOB_FROM_MANIFEST_ERROR = 'REMOVE_JOB_FROM_MANIFEST_ERROR',
    UPDATE_MANIFEST_EXTERNAL_REFERENCES_REQUEST = 'UPDATE_MANIFEST_EXTERNAL_REFERENCES_REQUEST',
    UPDATE_MANIFEST_EXTERNAL_REFERENCES_SUCCESS = 'UPDATE_MANIFEST_EXTERNAL_REFERENCES_SUCCESS',
    UPDATE_MANIFEST_EXTERNAL_REFERENCES_ERROR = 'UPDATE_MANIFEST_EXTERNAL_REFERENCES_ERROR',
}

export interface GET_MANIFEST_BY_ID_REQUEST extends Action {
    type: ManifestActions.GET_MANIFEST_BY_ID_REQUEST;
}
export interface GET_MANIFEST_BY_ID_SUCCESS extends Action {
    type: ManifestActions.GET_MANIFEST_BY_ID_SUCCESS;
    payload: Manifest;
}
export interface GET_MANIFEST_BY_ID_ERROR extends Action {
    type: ManifestActions.GET_MANIFEST_BY_ID_ERROR;
    error: ErrorResponse;
}

export interface CREATE_MANIFEST_REQUEST extends Action {
    type: ManifestActions.CREATE_MANIFEST_REQUEST;
}
export interface CREATE_MANIFEST_SUCCESS extends Action {
    type: ManifestActions.CREATE_MANIFEST_SUCCESS;
    payload: Manifest;
}
export interface CREATE_MANIFEST_ERROR extends Action {
    type: ManifestActions.CREATE_MANIFEST_ERROR;
    error: ErrorResponse;
}

export interface UPDATE_MANIFEST_REQUEST extends Action {
    type: ManifestActions.UPDATE_MANIFEST_REQUEST;
}
export interface UPDATE_MANIFEST_SUCCESS extends Action {
    type: ManifestActions.UPDATE_MANIFEST_SUCCESS;
    payload: Manifest;
}
export interface UPDATE_MANIFEST_ERROR extends Action {
    type: ManifestActions.UPDATE_MANIFEST_ERROR;
    error: ErrorResponse;
}

export interface ARCHIVE_MANIFEST_REQUEST extends Action {
    type: ManifestActions.ARCHIVE_MANIFEST_REQUEST;
}
export interface ARCHIVE_MANIFEST_SUCCESS extends Action {
    type: ManifestActions.ARCHIVE_MANIFEST_SUCCESS;
    payload: Manifest;
}
export interface ARCHIVE_MANIFEST_ERROR extends Action {
    type: ManifestActions.ARCHIVE_MANIFEST_ERROR;
    error: ErrorResponse;
}

export interface UNARCHIVE_MANIFEST_REQUEST extends Action {
    type: ManifestActions.UNARCHIVE_MANIFEST_REQUEST;
}
export interface UNARCHIVE_MANIFEST_SUCCESS extends Action {
    type: ManifestActions.UNARCHIVE_MANIFEST_SUCCESS;
    payload: Manifest;
}
export interface UNARCHIVE_MANIFEST_ERROR extends Action {
    type: ManifestActions.UNARCHIVE_MANIFEST_ERROR;
    error: ErrorResponse;
}

export interface ADD_JOB_TO_MANIFEST_REQUEST extends Action {
    type: ManifestActions.ADD_JOB_TO_MANIFEST_REQUEST;
}
export interface ADD_JOB_TO_MANIFEST_SUCCESS extends Action {
    type: ManifestActions.ADD_JOB_TO_MANIFEST_SUCCESS;
    payload: Manifest;
}
export interface ADD_JOB_TO_MANIFEST_ERROR extends Action {
    type: ManifestActions.ADD_JOB_TO_MANIFEST_ERROR;
    error: ErrorResponse;
}

export interface UPDATE_MANIFEST_EXTERNAL_REFERENCES_REQUEST extends Action {
    type: ManifestActions.UPDATE_MANIFEST_EXTERNAL_REFERENCES_REQUEST;
}
export interface UPDATE_MANIFEST_EXTERNAL_REFERENCES_SUCCESS extends Action {
    type: ManifestActions.UPDATE_MANIFEST_EXTERNAL_REFERENCES_SUCCESS;
    payload: Manifest;
}
export interface UPDATE_MANIFEST_EXTERNAL_REFERENCES_ERROR extends Action {
    type: ManifestActions.UPDATE_MANIFEST_EXTERNAL_REFERENCES_ERROR;
    error: ErrorResponse;
}

export type ManifestsActions =
    | CREATE_MANIFEST_REQUEST
    | CREATE_MANIFEST_SUCCESS
    | CREATE_MANIFEST_ERROR
    | GET_MANIFEST_BY_ID_REQUEST
    | GET_MANIFEST_BY_ID_SUCCESS
    | GET_MANIFEST_BY_ID_ERROR
    | UPDATE_MANIFEST_REQUEST
    | UPDATE_MANIFEST_SUCCESS
    | UPDATE_MANIFEST_ERROR
    | ARCHIVE_MANIFEST_REQUEST
    | ARCHIVE_MANIFEST_SUCCESS
    | ARCHIVE_MANIFEST_ERROR
    | UNARCHIVE_MANIFEST_REQUEST
    | UNARCHIVE_MANIFEST_SUCCESS
    | UNARCHIVE_MANIFEST_ERROR
    | ADD_JOB_TO_MANIFEST_REQUEST
    | ADD_JOB_TO_MANIFEST_SUCCESS
    | ADD_JOB_TO_MANIFEST_ERROR
    | UPDATE_MANIFEST_EXTERNAL_REFERENCES_REQUEST
    | UPDATE_MANIFEST_EXTERNAL_REFERENCES_SUCCESS
    | UPDATE_MANIFEST_EXTERNAL_REFERENCES_ERROR;
